// Hex palettes used by canvas-rendered effects (confetti, XP fly). The CSS
// tokens in index.css are the source of truth for *layout* color; this file
// mirrors a subset for *animation* code that can't read CSS variables (canvas
// + inline-styled motion). Keep them in sync by hand — Tailwind v4's
// @theme syntax doesn't expose values to JS at build time.

import type { PackId } from '@skena/schema'

/** Multi-color palette for confetti bursts. */
export const PACK_CONFETTI_COLORS: Record<PackId, string[]> = {
  // joseph: amber, sand, cream, deep orange, leaf — warm desert palette
  joseph: ['#c9722d', '#f5d68a', '#fff1c7', '#a85a1f', '#7a8c4a'],
  // nativity: night blue, lamp gold, snow, soft star-white, deep navy
  nativity: ['#1f3a5f', '#f5c542', '#f4f7fb', '#fff8d6', '#0d2240'],
}

/** Single primary hex per pack — for XP fly-up text and other accents. */
export const PACK_PRIMARY_HEX: Record<PackId, string> = {
  joseph: '#c9722d',
  nativity: '#1f3a5f',
}
